import sideMenu from './reducer';

export default sideMenu;
